var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { staticClass: "sales-stat-card" },
    [
      _c(
        "Row",
        { staticClass: "filter-bar", attrs: { gutter: 12 } },
        [
          _c("Col", { staticClass: "title" }, [_vm._v("📊 销售统计图表")]),
          _c(
            "Col",
            { staticClass: "filter-item" },
            [
              _c("DatePicker", {
                attrs: {
                  transfer: "",
                  type: "year",
                  placeholder: "选择年",
                  format: "yyyy",
                  "value-format": "yyyy",
                },
                on: { "on-change": _vm.handleSearch },
                model: {
                  value: _vm.year,
                  callback: function ($$v) {
                    _vm.year = $$v
                  },
                  expression: "year",
                },
              }),
            ],
            1
          ),
          this.$checkAccessArray(["S", "I"])
            ? _c(
                "Col",
                { staticClass: "filter-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("分组维度: ")]),
                  _c(
                    "RadioGroup",
                    {
                      attrs: { type: "button", size: "small" },
                      on: { "on-change": _vm.chooseGroup },
                      model: {
                        value: _vm.groupBy,
                        callback: function ($$v) {
                          _vm.groupBy = $$v
                        },
                        expression: "groupBy",
                      },
                    },
                    _vm._l(_vm.GROUP_BY_OPTS, function (o) {
                      return _c(
                        "Radio",
                        { key: o.value, attrs: { label: o.value } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(o.label) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "Col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.seedFarmListShow,
                  expression: "seedFarmListShow",
                },
              ],
            },
            [
              _c("span", { staticClass: "label" }, [_vm._v("苗场: ")]),
              _c(
                "Select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { transfer: "", filterable: "", clearable: "" },
                  on: { "on-change": _vm.handleSearch },
                  model: {
                    value: _vm.seedFarmUuid,
                    callback: function ($$v) {
                      _vm.seedFarmUuid = $$v
                    },
                    expression: "seedFarmUuid",
                  },
                },
                _vm._l(_vm.seedFarmList, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.seedFarmUuid } },
                    [
                      _vm._v(
                        _vm._s(item.seedFarmCode) +
                          "---" +
                          _vm._s(item.seedFarmName)
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.managerListShow,
                  expression: "managerListShow",
                },
              ],
            },
            [
              _c("span", { staticClass: "label" }, [_vm._v("客户经理: ")]),
              _c(
                "Select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { transfer: "", filterable: "", clearable: "" },
                  on: { "on-change": _vm.handleSearch },
                  model: {
                    value: _vm.managerUuid,
                    callback: function ($$v) {
                      _vm.managerUuid = $$v
                    },
                    expression: "managerUuid",
                  },
                },
                _vm._l(_vm.managerList, function (item, index) {
                  return _c(
                    "Option",
                    {
                      key: index,
                      attrs: { value: item.userCustomerManagerLoginUuid },
                    },
                    [
                      _vm._v(
                        _vm._s(item.userCustomerManagerCode) +
                          "---" +
                          _vm._s(item.userCustomerManagerName)
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.distributionStationListShow,
                  expression: "distributionStationListShow",
                },
              ],
            },
            [
              _c("span", { staticClass: "label" }, [_vm._v("转运站: ")]),
              _c(
                "Select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { transfer: "", filterable: "", clearable: "" },
                  on: { "on-change": _vm.handleSearch },
                  model: {
                    value: _vm.distributionStationUuid,
                    callback: function ($$v) {
                      _vm.distributionStationUuid = $$v
                    },
                    expression: "distributionStationUuid",
                  },
                },
                _vm._l(_vm.distributionStationList, function (item, index) {
                  return _c(
                    "Option",
                    {
                      key: index,
                      attrs: { value: item.distributionStationUuid },
                    },
                    [
                      _vm._v(
                        _vm._s(item.distributionStationCode) +
                          "---" +
                          _vm._s(item.distributionStationName)
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            [
              _c(
                "Button",
                {
                  staticClass: "search-btn",
                  attrs: {
                    size: "small",
                    type: "primary",
                    shape: "circle",
                    icon: "ios-search",
                  },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Spin",
        {
          attrs: {
            spinning: _vm.loading || !_vm.dataLoaded,
            tip: _vm.loading ? "数据加载中..." : "等待数据...",
          },
        },
        [
          _c("section", { staticClass: "chart-wrapper" }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chartsInitialized && _vm.dataLoaded,
                  expression: "chartsInitialized && dataLoaded",
                },
              ],
              ref: "barChartRef",
              staticStyle: { width: "100%", height: "400px" },
            }),
            !_vm.chartsInitialized || !_vm.dataLoaded
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      height: "400px",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      background: "#f5f5f5",
                      "border-radius": "8px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "12px" } },
                        [
                          _c("Icon", {
                            staticClass: "spin-icon-load",
                            attrs: { type: "ios-loading", size: "24" },
                          }),
                        ],
                        1
                      ),
                      _c("span", { staticStyle: { color: "#666" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.loading ? "图表初始化中..." : "等待数据加载..."
                          )
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c("section", { staticClass: "chart-wrapper" }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chartsInitialized && _vm.dataLoaded,
                  expression: "chartsInitialized && dataLoaded",
                },
              ],
              ref: "lineChartRef",
              staticStyle: { width: "100%", height: "400px" },
            }),
            !_vm.chartsInitialized || !_vm.dataLoaded
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      height: "400px",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      background: "#f5f5f5",
                      "border-radius": "8px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "12px" } },
                        [
                          _c("Icon", {
                            staticClass: "spin-icon-load",
                            attrs: { type: "ios-loading", size: "24" },
                          }),
                        ],
                        1
                      ),
                      _c("span", { staticStyle: { color: "#666" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.loading ? "图表初始化中..." : "等待数据加载..."
                          )
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }